import { render, staticRenderFns } from "./AvgProductRow.vue?vue&type=template&id=41fd03f2&scoped=true&"
import script from "./AvgProductRow.vue?vue&type=script&lang=js&"
export * from "./AvgProductRow.vue?vue&type=script&lang=js&"
import style0 from "./AvgProductRow.vue?vue&type=style&index=0&id=41fd03f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd03f2",
  null
  
)

export default component.exports